/** Writes a guide into the localStorage keys the guide editor (`/create-guide`) loads from. */
export function writeGuideEditStorage(flowData: any): void {
  localStorage.removeItem("selectedCategoryName");

  const flowCoverPage = {
    coverImage: flowData.url,
    rowKey: flowData.rowKey,
    description: flowData.description,
    coverPosterPageURI:
      flowData.videoThumbNailUrl || flowData.VideoThumbNailUrl || "",
    title: flowData.title,
    type: flowData.type || flowData.Type || "Flow",
    fileName: flowData.fileName,
    uniqueId: flowData.uniqueId,
    duration: flowData.duration,
    durationUnit: flowData.durationUnit || "Mins",
    price: flowData.price,
    isPaid: flowData.isPaid,
    customerEmail: flowData.customerEmail,
    partitionKey: flowData.customerEmail,
    searchKeyWords: flowData.searchKeyWords,
    coverIsSafetyCritical: flowData.CoverIsSafetyCritical || flowData.coverIsSafetyCritical || false,
    coverSafetyInstructionsTitle: flowData.CoverSafetyInstructionsTitle || flowData.coverSafetyInstructionsTitle || "",
    coverSafetyInstructionsDescription: flowData.CoverSafetyInstructionsDescription || flowData.coverSafetyInstructionsDescription || "",
    isSponsored: flowData.isSponsored || flowData.IsSponsored || false,
    // Collaboration
    isCollaboration: flowData.isCollaboration || flowData.IsCollaboration || false,
    coAuthorEmail: flowData.coAuthorEmail || flowData.CoAuthorEmail || null,
    coAuthorEmails: flowData.coAuthorEmails || flowData.CoAuthorEmails || null,
    coAuthorUserNames: flowData.coAuthorUserNames || flowData.CoAuthorUserNames || null,
    coAuthorProfilePicUrls: flowData.coAuthorProfilePicUrls || flowData.CoAuthorProfilePicUrls || null,
    coAuthorUserName: flowData.coAuthorUserName || flowData.CoAuthorUserName || null,
    coAuthorProfilePicUrl: flowData.coAuthorProfilePicUrl || flowData.CoAuthorProfilePicUrl || null,
    collaborationValue: flowData.collaborationValue || flowData.CollaborationValue || null,
    collaborationStatus: flowData.collaborationStatus || flowData.CollaborationStatus || null,
    accessType: flowData.accessType || flowData.AccessType || "",
    restrictedAccessType:
      flowData.restrictedAccessType || flowData.RestrictedAccessType || "",
    isSearchHidden: flowData.isSearchHidden ?? flowData.IsSearchHidden,
    restrictedAccessFlows:
      flowData.restrictedAccessFlows || flowData.RestrictedAccessFlows || [],
    enforceNetwork: flowData.enforceNetwork || flowData.EnforceNetwork || false,
    enforceGeo: flowData.enforceGeo || flowData.EnforceGeo || false,
    enforceDevice: flowData.enforceDevice || flowData.EnforceDevice || false,
    enforceCompanyEmail:
      flowData.enforceCompanyEmail || flowData.EnforceCompanyEmail || false,
    allowedCidrs: flowData.allowedCidrs || flowData.AllowedCidrs || "",
    allowedEmailDomains:
      flowData.allowedEmailDomains || flowData.AllowedEmailDomains || "",
    allowedDeviceIds: flowData.allowedDeviceIds || flowData.AllowedDeviceIds || "",
    geoFenceJson: flowData.geoFenceJson || flowData.GeoFenceJson || null,
    endQuestionForm: flowData.endQuestionForm ?? flowData.EndQuestionForm ?? null,
  };

  localStorage.setItem("flowCoverPageDetails", JSON.stringify(flowCoverPage));
  const steps = Array.isArray(flowData.steps)
    ? flowData.steps.map((step: any) => ({
        ...step,
        taggedItems: step.taggedItems || step.TaggedItems || [],
        questionForm: step.questionForm ?? step.QuestionForm ?? null,
      }))
    : flowData.steps;
  localStorage.setItem("stepsCoverPageDetails", JSON.stringify(steps));
  localStorage.setItem(
    "SupportingDocumentDocuments",
    JSON.stringify(flowData.flowSupportingDocumentsDocumentModels)
  );
  localStorage.setItem(
    "SupportingDocumentHyperLinksRequired",
    JSON.stringify(flowData.flowSupportingDocumentsHyperLinkModels)
  );
  localStorage.setItem("ItemsRequired", JSON.stringify(flowData.components));
  localStorage.removeItem("draftWord");
  localStorage.setItem("editWord", "Edit Content");
}
